import e from "../managers/braze-instance.js";
import se from "./in-app-message-manager-factory.js";
export function getDeferredInAppMessage() {
  if (e.rr()) return se.m().Re();
}
